import { defineMessage, MessageDescriptor } from 'react-intl';
import dayjs from 'dayjs';
import 'dayjs/locale/en-ca';
import 'dayjs/locale/fr-ca';

export interface SupportedLocale {
  code: string,
  nameDescriptor: MessageDescriptor,
  messages?: Record<string, string>,
}

export interface I18nMessages {
  [locale: string]: {
    [id: string]: string;
  };
}

export const allSupportedLocales: SupportedLocale[] = [
  { code: 'en-CA', nameDescriptor: defineMessage({ id: 'English' }), messages: require('./assets/locales/en-CA.json') },
  { code: 'fr-CA', nameDescriptor: defineMessage({ id: 'French' }), messages: require('./assets/locales/fr-CA.json') },
];

export const defaultLocale = allSupportedLocales[1];

dayjs.locale(defaultLocale.code);